import React, { useState } from 'react'
import axios from "axios";
import './Signup.css';
import UserService from '../services/UserService';

function SignUp() {
  const [signupdetail, setSignupDetail] = useState({
    email: ""
  });
  const [status, setStatus] = useState("idle") // idle | sending | done | error

  const signupdata = (e) => {
    e.preventDefault();

    if (signupdetail.email.trim() === '') {
      return
    }
    setStatus("sending")
    axios.post(UserService.getURl() + "/signup/add", signupdetail, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data'
      }
    }).then(response => {
      if (response.data != null) {
        setStatus("done")
        setSignupDetail({ email: "" })
      }
    }).catch(error => {
      console.error("Sign up failed", error)
      setStatus("error")
    })
  }

  const handlechange = (e) => {
    setSignupDetail({ ...signupdetail, [e.target.name]: e.target.value })
  }

  return (
    <section className="signup-band">
      <div className="signup-text">
        <h3>Never miss a deal 🦖</h3>
        <p>Get the best deals in your inbox. We'll never share your email with anyone else.</p>
      </div>

      {status === "done" ? (
        <p className="signup-thanks">Thank you for signing up! 🎉</p>
      ) : (
        <form className="signup-form" method='post' onSubmit={signupdata}>
          <input
            type="email"
            name="email"
            placeholder="Enter your email"
            aria-label="Email address"
            value={signupdetail.email}
            onChange={handlechange}
            required
          />
          <button type="submit" disabled={status === "sending"}>
            {status === "sending" ? "Signing up..." : "Sign Up"}
          </button>
          {status === "error" && (
            <p className="signup-error">Something went wrong. Please try again.</p>
          )}
        </form>
      )}
    </section>
  )
}

export default SignUp
